import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route, BrowserRouter, Router } from 'react-router-dom'
import { createBrowserHistory as createHistory } from "history";
import Home from './components/Home/Container';
import Page from './components/Page/Container';
import Admin from './components/Admin';
import Pages from './components/Pages/Container';
import Albums from './components/Albums/Container';
import Album from './components/Album/Container';
import EventShow from './components/EventShow/Container';
import PasswordReset from './components/PasswordReset/Container';
import PasswordUpdate from './components/PasswordUpdate/Container';
import Events from './components/Events/Container';
import Streamings from './components/Streamings/Container';
import Podcasts from './components/Podcasts/Container';
import Contact from './components/Contact/Container';
import Layout from './components/Layout'
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import reducers from './reducers';
import thunk from 'redux-thunk';
import AuthneticationProvider from './utils/AuthneticationProvider/Container'
import ProivateRoute from './utils/PrivateRoute/Container'
import PublicRoute from './utils/PublicRoute/Container'

let store = createStore(
    reducers,
    applyMiddleware(thunk)
);


ReactDOM.render(
	<Provider store={store}>
	<AuthneticationProvider>
	<Router history={createHistory()}>

	<Layout>
	<Switch>
       	<Route exact path='/' component={Home} />
	<Route path='/events/:id' component={EventShow} />
	<Route path='/events' component={Events} />
	<Route path='/pages/:name' component={Page} />
	<Route path='/podcasts/:id' component={Podcasts} />
	<Route path='/podcasts' component={Podcasts} />
	<Route path='/albums/:id' component={Album} />
	<Route path='/albums' component={Albums} />
	<Route path='/live' component={Streamings} />	
	<Route path='/contact' component={Contact} />
	<PublicRoute path='/passwordReset' component={PasswordReset} />
	<PublicRoute path='/passwordUpdate/:token' component={PasswordUpdate} />
	<ProivateRoute path='/pages' component={Pages} />
	<PublicRoute path='/admin' component={Admin} />
        </Switch>
	</Layout>
	</Router>
	</AuthneticationProvider>

    </Provider>
	, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js